import Repository from '@/repositories/Repository'
import AlertHistories from '@/models/AlertHistories'

export type AlertHistoryParams = {
  range: {
    startTime: string
    endTime: string
  }
  stationId: string
}

class AlertHistoryRepository extends Repository {
  constructor() {
    super('/alert_history')
  }

  async get(params: AlertHistoryParams) {
    const attributes = await super._post<AlertHistoryParams>(params)

    return new AlertHistories(attributes.items)
  }
}

export default AlertHistoryRepository
